import axios from 'axios'
import { useEffect, useState } from 'react'
import { constants } from '../Constants'
import { PageLoader } from '../components/ui/Spinner/Spinner'
import { useToast } from '../components/ui/Toast/Toast'
import '../styles/shared.scss'

export const Emails = () => {
  const [unpaidUsers, setUnpaidUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [sending, setSending] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const toast = useToast()

  const fetchUnpaid = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${constants.urlLocal}auth/getUnpaidUsers`)
      setUnpaidUsers(res.data.users || [])
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchUnpaid()
  }, [])

  const sendReminders = async () => {
    setSending(true)
    setConfirmOpen(false)
    try {
      await axios.post(`${constants.urlLocal}auth/sendPaymentReminders`)
      toast({ title: 'Recordatorios enviados', status: 'success' })
    } catch (error) {
      toast({ title: 'Error al enviar', status: 'error' })
    }
    setSending(false)
  }

  if (loading)
    return (
      <div className="loading-center">
        <PageLoader />
      </div>
    )

  return (
    <div className="page-container">
      <div className="flex-between" style={{ marginBottom: '1.5rem' }}>
        <h2 className="page-title" style={{ marginBottom: 0 }}>
          Recordatorios de pago
        </h2>
        <button
          className="btn btn--primary"
          disabled={sending || unpaidUsers.length === 0}
          onClick={() => setConfirmOpen(true)}
        >
          {sending
            ? 'Enviando...'
            : `Enviar recordatorios (${unpaidUsers.length})`}
        </button>
      </div>

      {unpaidUsers.length === 0 ? (
        <p className="empty-state">
          🎉 Todos los usuarios están al día con sus pagos
        </p>
      ) : (
        <>
          <p style={{ color: '#666', marginBottom: '1rem' }}>
            Hay <strong>{unpaidUsers.length}</strong> usuario(s) pendiente(s) de
            pago. Puedes enviarles un recordatorio por email.
          </p>
          <table className="data-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>Último pago</th>
              </tr>
            </thead>
            <tbody>
              {unpaidUsers.map(u => (
                <tr key={u._id}>
                  <td>
                    {u.name} {u.lastname}
                  </td>
                  <td>{u.email}</td>
                  <td>
                    {u.lastPaymentDate
                      ? new Date(u.lastPaymentDate).toLocaleDateString('es-ES')
                      : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* Confirm modal */}
      {confirmOpen && (
        <div className="confirm-dialog">
          <div
            className="confirm-dialog__overlay"
            onClick={() => setConfirmOpen(false)}
          />
          <div className="confirm-dialog__box">
            <h3>¿Enviar recordatorios?</h3>
            <p>
              Se enviará un email de recordatorio de pago a{' '}
              <strong>{unpaidUsers.length}</strong> usuario(s).
            </p>
            <div
              style={{
                display: 'flex',
                gap: '0.75rem',
                justifyContent: 'flex-end',
                marginTop: '1rem',
              }}
            >
              <button
                className="btn btn--secondary"
                onClick={() => setConfirmOpen(false)}
              >
                Cancelar
              </button>
              <button className="btn btn--primary" onClick={sendReminders}>
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
